export default __webpack_public_path__ + "static/media/mumbai1.6f460c3b.jpg";